// extracted by mini-css-extract-plugin
export var active = "side-nav-section-module--active--b49bf";
export var capitalize = "side-nav-section-module--capitalize--c54f2";
export var expanded = "side-nav-section-module--expanded--eed7f";
export var expander = "side-nav-section-module--expander--f21e7";
export var group = "side-nav-section-module--group--ac98e";
export var groupText = "side-nav-section-module--groupText--ed328";
export var page = "side-nav-section-module--page--66e36";
export var section = "side-nav-section-module--section--d563f";